export var TableCellVariantType;
(function (TableCellVariantType) {
    TableCellVariantType["HEADER_CELL"] = "HEADER_CELL";
    TableCellVariantType["BODY_CELL"] = "BODY_CELL";
})(TableCellVariantType || (TableCellVariantType = {}));
//# sourceMappingURL=variants.js.map